import { bool, number, oneOfType, shape, string } from 'prop-types'

import { VehicleObjectModel } from '../../models/vehicle/vehicle-object-model'
import { idPropType } from '../common/id-prop-type'
import { iso8601PropType } from '../common/iso-8601-prop-type'
import { iso3166CountryPropType } from '../common/iso-3166-country-prop-type'
import { iso3166SubdivisionPropType } from '../common/iso-3166-subdivision-prop-type'
import { locationDescriptionPropType } from '../common/location-description-prop-type'
import { positionPropType } from '../common/position-prop-type'
import { logbookModePropType } from '../logbook/logbook-mode-prop-type'
import { tripModePropType } from '../trip/trip-mode-prop-type'
import { energyConsumptionPreferencePropType } from './energy-consumption-preference-prop-type'
import { fuelTypePropType } from './fuel-type-prop-type'
import { objectClassPropType } from './object-class-prop-type'
import { objectColorPropType } from './object-color-prop-type'
import { objectControlFlagPropType } from './object-control-flag-prop-type'
import { objectFuelUsagePropType } from './object-fuel-usage-prop-type'
import { objectTypePropType } from './object-type-prop-type'
import { stealthModePropType } from './stealth-mode-prop-type'
import { telematicDeviceAccessoryPropType } from './telematic-device-accessory-prop-type'
import { vehicleGenerationPropType } from './vehicle-generation-prop-type'
import { vehicleUsageTypePropType } from './vehicle-usage-type-prop-type'

const {
    AVERAGE_ENERGY_CONSUMPTION,
    AVERAGE_FUEL_CONSUMPTION,
    COLOR,
    CONTROL_FLAGS,
    COURSE,
    CUSTOM_VEHICLE_ENERGY_CONSUMPTION,
    CUSTOM_VEHICLE_FUEL_CONSUMPTION,
    DESTINATION,
    DESTINATION_POSITION,
    ENERGY_CONSUMPTION_PREFERENCE,
    ENGINE_TOTAL_FUEL_USAGE,
    ETA,
    FUEL_TYPE,
    FUEL_USAGE_PREFERENCE,
    GEAR_SHIFT_RPM,
    IGNITION_ON,
    IMAGE_ID,
    LAST_CONNECTED_TACHOGRAPH,
    LAST_GPS_TIME,
    LAST_MODIFIED,
    LICENSE_PLATE,
    LICENSE_PLATE_COUNTRY_CODE,
    LICENSE_PLATE_FEDERAL_STATE_CODE,
    LOCATION_DESCRIPTION,
    LOGBOOK_MODE,
    NAME,
    NUMBER,
    OBJECT_CLASS,
    OBJECT_ID,
    ODOMETER,
    POSITION,
    POSITION_ADDRESS_ID,
    SPEED,
    SPEED_LIMIT,
    STANDSTILL,
    STANDSTILL_MSG_TIME,
    STEALTH_MODE,
    STEALTH_MODE_MSG_TIME,
    TELEMATIC_DEVICE_BATTERY_CHARGING_STATE,
    TELEMATIC_DEVICE_BATTERY_LEVEL_PERCENTAGE,
    TRIP_MODE,
    TYPE,
    VEHICLE_GENERATION,
    VEHICLE_USAGE_TYPE,
    VIN
} = VehicleObjectModel

const vehicleObjectType = {
    [AVERAGE_ENERGY_CONSUMPTION]: number,
    [AVERAGE_FUEL_CONSUMPTION]: number,
    [COLOR]: objectColorPropType,
    [CONTROL_FLAGS]: objectControlFlagPropType,
    [COURSE]: number,
    [CUSTOM_VEHICLE_ENERGY_CONSUMPTION]: number,
    [CUSTOM_VEHICLE_FUEL_CONSUMPTION]: number,
    [DESTINATION]: string,
    [DESTINATION_POSITION]: positionPropType,
    [ENERGY_CONSUMPTION_PREFERENCE]: energyConsumptionPreferencePropType,
    [ENGINE_TOTAL_FUEL_USAGE]: number,
    [ETA]: iso8601PropType,
    [FUEL_TYPE]: fuelTypePropType,
    [FUEL_USAGE_PREFERENCE]: objectFuelUsagePropType,
    [GEAR_SHIFT_RPM]: number,
    [IGNITION_ON]: bool,
    [IMAGE_ID]: oneOfType([idPropType, number]),
    [LAST_CONNECTED_TACHOGRAPH]: telematicDeviceAccessoryPropType,
    [LAST_GPS_TIME]: iso8601PropType,
    [LAST_MODIFIED]: number,
    [LICENSE_PLATE]: string,
    [LICENSE_PLATE_COUNTRY_CODE]: iso3166CountryPropType,
    [LICENSE_PLATE_FEDERAL_STATE_CODE]: iso3166SubdivisionPropType,
    [LOCATION_DESCRIPTION]: locationDescriptionPropType,
    [LOGBOOK_MODE]: logbookModePropType,
    [NAME]: string,
    [NUMBER]: string,
    [OBJECT_CLASS]: objectClassPropType,
    [OBJECT_ID]: idPropType,
    [ODOMETER]: number,
    [POSITION]: positionPropType,
    [POSITION_ADDRESS_ID]: idPropType,
    [SPEED]: number,
    [SPEED_LIMIT]: number,
    [STANDSTILL]: bool,
    [STANDSTILL_MSG_TIME]: iso8601PropType,
    [STEALTH_MODE]: stealthModePropType,
    [STEALTH_MODE_MSG_TIME]: iso8601PropType,
    [TELEMATIC_DEVICE_BATTERY_CHARGING_STATE]: string,
    [TELEMATIC_DEVICE_BATTERY_LEVEL_PERCENTAGE]: number,
    [TRIP_MODE]: tripModePropType,
    [TYPE]: objectTypePropType,
    [VEHICLE_GENERATION]: vehicleGenerationPropType,
    [VEHICLE_USAGE_TYPE]: vehicleUsageTypePropType,
    [VIN]: string
}
Object.freeze(vehicleObjectType)

export const vehicleObjectPropType = shape(vehicleObjectType)
